import React from 'react'
import ResultItem from '../../pack/form/result/ResultItem'
import { useSelector } from 'react-redux'

const UserInfoProfile = () => {

    const user = useSelector(state => state.user.user)

  return (
    <div className='packResultBlock'>
        <p className='packResultBlock__text'>Дані людини</p>
        <div className='packResultBlock__list'>
            <ResultItem
                text='Імʼя'
                value={user ? user.name : ''}
            />
            <ResultItem
                text='Прізвище'
                value={user ? user.surname : ''}
            />
            <ResultItem
                text='Email'
                value={user ? user.email : ''}
            />
        </div>
    </div>
  )
}

export default UserInfoProfile